const BGContainerSchema = ({ schema, intl }) => {
  const baseSchema = schema || {
    title: 'Container',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],
    properties: {},
    required: [],
  };

  const defaultFieldset =
    baseSchema.fieldsets?.find((item) => item.id === 'default') || {
      id: 'default',
      title: 'Default',
      fields: [],
    };

  const otherFieldsets =
    baseSchema.fieldsets?.filter((item) => item.id !== 'default') || [];

  return {
    ...baseSchema,
    fieldsets: [
      {
        ...defaultFieldset,
        fields: [...defaultFieldset.fields, 'fullWidth'],
      },
      ...otherFieldsets,
    ],
    properties: {
      ...baseSchema.properties,
      fullWidth: {
        title: 'Über volle Breite',
        type: 'boolean',
        default: false,
      },
    },
    required: baseSchema.required || [],
  };
};

export default BGContainerSchema;
